import { useQuery } from '@tanstack/react-query';

import { userQueryKeys } from '@p/security/users/dashboard/hook/queries/query-key';

import { userManageService } from 'services/usermanage.service';

export const useFetchUsers = () => {
  return useQuery({
    queryFn: async () => {
      return await userManageService.getUsers();
    },
    queryKey: userQueryKeys.all,
  });
};
